import { useEffect } from 'react'

export function useGoogleAd ({ path, size, id }) {
  useEffect(() => {
    const googletag = window.googletag || {}
    googletag.cmd = window.googletag.cmd || []

    googletag.cmd.push(function () {
      window.googletag_slots[`${id}_${window.afdDevice}`] = window.googletag.defineSlot('/1021178/' + path, size, id)
        .addService(window.googletag.pubads())
      googletag.pubads().enableSingleRequest()
      googletag.pubads().collapseEmptyDivs()
      googletag.enableServices()
    })
    googletag.cmd.push(function () {
      googletag.display(id)
    })
  }, [path, size, id])
}
